import { logger } from 'src/services';

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    logger.error('Error copying to clipboard:', {}, error as Error);
    throw error;
  }
};

export const copyRichTextToClipboard = async (richText: string) => {
  try {
    const tempElement = document.createElement('div');

    // Sanitize the HTML content before setting innerHTML
    tempElement.innerHTML = richText;

    document.body.appendChild(tempElement);
    const range = document.createRange();
    range.selectNode(tempElement);
    window.getSelection()?.removeAllRanges();
    window.getSelection()?.addRange(range);
    document.execCommand('copy');
    document.body.removeChild(tempElement);
  } catch (error) {
    logger.error('Error copying rich text to clipboard:', {}, error as Error);
    throw error;
  }
};
